<script lang="ts">
	import { format } from 'svelte-i18n';
	// Design system
	import { Alert } from '@Shelly/shelly-design-system/index';
	//Components
	import TemplateToggleSettings from '../../Components/TemplateToggleSettings.svelte';
	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;
</script>

<TemplateToggleSettings
	class="mb-s"
	{device}
	setting="randomize_delay"
	subSetting="enable"
	title={$format('enable', { default: 'Enable' })}
/>

<Alert
	heading={$format('ev_charger_randomize_delay_info', {
		default:
			'When enabled, delays the actual charging start by a random 1 - 15 seconds after the start command is received.',
	})}
/>
